import { RangoSerializable } from '@/models/componentes/datePicker.model';
import { format, setDefaultOptions, parse, formatISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { DateRange } from 'react-day-picker';

setDefaultOptions({ locale: es });

export const timeZone = 'America/Santiago';

type FormatosFechas = 'dd-MM-yyyy HH:mm' | 'dd-MM-yyyy';

export const formatDate = (
  date: Date,
  formato: FormatosFechas = 'dd-MM-yyyy'
): string => {
  if (date) {
    const formattedDate = format(date, formato);

    return formattedDate;
  }
};

export const parseDate = (
  date: string,
  formato: FormatosFechas = 'dd-MM-yyyy'
): Date => {
  if (date) {
    const parsedDate = parse(date, formato, new Date());

    return parsedDate;
  }
};

// Utilidad para almacenar rangos serializables de react day picker en la store de redux
export const parseRangeToSerializable = ({
  from,
  to,
}: DateRange): RangoSerializable => {
  return {
    from: formatISO(from),
    to: formatISO(to),
  };
};

// Aplicar rangos almacenados en store de redux en day picker
export const parseRangeToDate = ({
  from,
  to,
}: {
  from: string | number;
  to: string | number;
}): DateRange => {
  return {
    from: new Date(from),
    to: new Date(to),
  };
};
